// assets
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import { IconDashboard } from '@tabler/icons';

const regularMenu = {
  items: [
    {
      id: 'grouplife site-map',
      type: 'group',
      children: [
        {
          id: 'home',
          title: 'Dashboard',
          type: 'item',
          url: '/home',
          icon: IconDashboard,
          external: false,
          target: false
        },
        {
          id: 'user',
          title: 'Profile',
          type: 'item',
          url: 'user/account/profile',
          icon: AccountBoxIcon,
          external: false,
          target: false
        }
      ]
    }
  ]
};

export default regularMenu;
